import formatRelativeTodayTomorrowDate from '../../../../../../utils/format-relative-today-tomorrow-date'
import ActivityCard from '../ActivityCard'
import { EventBookableItem } from '../ActivityCard/ActivityCard.types'
import type { Locale } from '../../../../../../../localization/i18n'

interface Props {
  groupDate: string
  timeZone?: string
  activities: Array<EventBookableItem>
  locale: Locale
  hasPriority: boolean
}

// TODO - we need a timezone for the city or something
// each activity can kinda leverage the venue's timezone
// but at a grouped level, maybe the city's time zone makes sense.
const ActivityDateGroup = ({ groupDate, activities, locale, hasPriority: groupHasPriority }: Props) => {
  const formattedDate = formatRelativeTodayTomorrowDate({
    date: new Date(groupDate),
    locale,
    dateFormatOptions: { month: '2-digit', day: '2-digit', weekday: 'short' },
  })
  return (
    <div className="flex w-full flex-col gap-1 py-3 sm:px-2">
      <h2 className="mb-2 px-2 text-xl font-medium capitalize sm:px-0">{formattedDate}</h2>
      <ul className="grid grid-cols-1 gap-0.5 sm:grid-cols-2 sm:gap-2 lg:grid-cols-3">
        {activities.map((activity, index) => (
          <ActivityCard
            key={activity.id}
            activity={activity}
            locale={locale}
            hasPriority={groupHasPriority && index <= 6}
          />
        ))}
      </ul>
    </div>
  )
}

export default ActivityDateGroup
